import merge from 'lodash/merge';

// https://easysnippets.com/how-to-lighten-darken-a-color-with-javascript/
function lightenDarkenColor(color, amount) {
	let colorWithoutHash = color.replace('#', '');
	if (colorWithoutHash.length === 3) {
		colorWithoutHash = colorWithoutHash
			.split('')
			.map(c => `${c}${c}`)
			.join('');
	}

	const getColorChannel = substring => {
		let colorChannel = Number.parseInt(substring, 16) + amount;
		colorChannel = Math.max(Math.min(255, colorChannel), 0).toString(16);

		if (colorChannel.length < 2) {
			colorChannel = `0${colorChannel}`;
		}

		return colorChannel;
	};

	const colorChannelRed = getColorChannel(colorWithoutHash.slice(0, 2));
	const colorChannelGreen = getColorChannel(colorWithoutHash.slice(2, 4));
	const colorChannelBlue = getColorChannel(colorWithoutHash.slice(4, 6));

	return `#${colorChannelRed}${colorChannelGreen}${colorChannelBlue}`;
}

const brandFontFamily =
	'\'Merriweather Sans\', \'Helvetica Neue\', \'Helvetica\', \'Arial\', \'sans-serif\'';

const colors = {
	viewed: '#be1818',
	investigated: '#007373',
	cited: '#0070a8',
	published: '#c75301'
};

const sharedChartOptions = {
	data: {
		datasets: [{
			label: '',
			fill: false
		}]
	},
	options: {
		parsing: {
			xAxisKey: 'year',
			yAxisKey: 'value'
		},
		scales: {
			x: {
				title: {
					align: 'center'
				},
				ticks: {
					font: {
						family: brandFontFamily,
						size: 18
					}
				}
			},
			y: {
				beginAtZero: true,
				ticks: {
					font: {
						family: brandFontFamily,
						size: 18
					}
				}
			}
		},
		plugins: {
			tooltip: {
				backgroundColor: '#FFF',
				bodyColor: '#4A4A4A',
				bodyFont: {size: 18},
				displayColors: false,
				borderWidth: 1,
				callbacks: {
					title: () => {},
					label: context => {
						const value = context.formattedValue;
						return value;
					}
				}
			},
			legend: {
				display: false
			}
		}
	}
};

export function getChartOptions(
	allAvailableYears,
	valuesForGivenMetricType,
	metricsType,
	chartType) {
	const barChartOptions = {
		type: 'bar',
		data: {
			labels: allAvailableYears,
			datasets: [{
				data: valuesForGivenMetricType,
				backgroundColor: colors[metricsType],
				hoverBackgroundColor: lightenDarkenColor(colors[metricsType], 20),
				borderColor: colors[metricsType],
				borderWidth: 0,
				barPercentage: 1
			}]
		},
		options: {
			plugins: {
				tooltip: {
					borderColor: colors[metricsType]
				}
			},
			scales: {
				x: {
					grid: {
						display: false
					}
				}
			}
		}
	};

	const lineChartOptions = {
		type: 'line',
		data: {
			labels: allAvailableYears,
			datasets: [{
				data: valuesForGivenMetricType,
				borderColor: colors[metricsType],
				borderWidth: 5,
				pointBackgroundColor: '#FFF',
				pointRadius: 4,
				pointBorderWidth: 1,
				pointHitRadius: 30,
				pointHoverBackgroundColor: 'rgba(255,255,255)',
				pointHoverRadius: 7,
				pointHoverBorderWidth: 3
			}]
		},
		options: {
			plugins: {
				tooltip: {
					borderColor: colors[metricsType]
				}
			}
		}
	};

	const mergedBarChartOptions = merge(barChartOptions, sharedChartOptions);
	const mergedLineChartOptions = merge(lineChartOptions, sharedChartOptions);

	return chartType === 'bar' ? mergedBarChartOptions : mergedLineChartOptions;
}
